<template>
  <div class="row card borderless-card" style="box-shadow: none">
    <div class="row ml-0 mr-0" style="padding-left: 30px">
      <div :class="mainDiligenceCls">
        <div
          class="row mb-3"
          style="justify-content: space-between; margin: auto"
        >
          <div class="team-title mt-2 d-flex">
            <!-- <i class="material-icons-outlined user-font mr-2 material-icon-font"
              >search</i
            > -->
            <img src="static/img/notes-eye.svg" style="margin: 0 8px 0 0" />
            <div style="margin-top: auto; margin-bottom: auto">Diligence</div>
          </div>
        </div>
        <div class="text-right">
          <button
            class="newTask mr-2"
            v-if="customizedWorkflows"
            style="margin-top: 15px; margin-right: 15px"
            @click="handleManageStage()"
          >
            Manage Stage
          </button>
          <button
            class="newTask"
            style="margin-top: 15px; margin-right: 15px"
            v-if="showAddCompany()"
            @click="handleCreateDiligence()"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
            Add Company
          </button>
        </div>
        <b-tabs v-if="suggestionRefresh">
          <b-tab
            @click="
              displayArchive = false;
              displayActive = true;
            "
            title="Active"
            active-nav-item-class="border-bottom: #5445F3 0% 0% no-repeat padding-box"
            active
          >
            <ActiveDiligence
              v-if="displayActive"
              ref="activeRef"
            ></ActiveDiligence>
          </b-tab>
          <b-tab
            title="Archived"
            @click="
              displayArchive = true;
              displayActive = false;
            "
          >
            <ArchivedDiligence
              v-if="displayArchive"
              ref="archiveRef"
            ></ArchivedDiligence>
          </b-tab>
        </b-tabs>
      </div>
      <div :class="suggestionDiligenceCls">
        <div
          class="d-flex suggestionToggle"
          @click="isMinimized = !isMinimized"
        >
          <i
            v-if="isMinimized"
            class="fas fa-arrow-left"
            style="margin: auto"
          ></i>
          <i v-else class="fas fa-arrow-right" style="margin: auto"></i>
        </div>
        <SuggestionDiligence :isMinimized="isMinimized"></SuggestionDiligence>
      </div>
    </div>
    <AddDiligence
      @success-emit="checkDataStatus"
      v-model="dialogDiligenceData"
    ></AddDiligence>
    <DialogManageStage v-model="dialogStageData"></DialogManageStage>
  </div>
</template>
<script>
import ArchivedDiligence from "./ArchivedDiligence";
import ActiveDiligence from "./ActiveDiligence";
import SuggestionDiligence from "./SuggestionDiligence";
import AddDiligence from "../Dialogs/AddDiligence";
import DialogManageStage from "../Dialogs/DialogManageStage";
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  computed: {
    ...mapGetters("portfolio", ["portfolioAll", "portfolioCount"]),
    ...mapGetters("workspacePlans", ["feature", "plan"]),
    ...mapGetters("workspace", ["currentWorkspace"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    mainDiligenceCls() {
      if (this.isMinimized) return "col-11 pl-0 pr-0";
      if (!this.isMinimized) return "col-8 pl-0 pr-0";
    },
    suggestionDiligenceCls() {
      if (this.isMinimized) return "col-1 pl-0 pr-0 suggestionColCard";
      if (!this.isMinimized) return "col-4 pl-0 pr-0 suggestionColCard";
    },
    customizedWorkflows() {
      let featureIndex = this.feature.findIndex((item) => {
        if (item == "CUSTOMIZED_WORKFLOWS") return item;
      });
      if (featureIndex >= 0) return true;
      else return false;
    },
  },
  components: {
    ArchivedDiligence,
    ActiveDiligence,
    SuggestionDiligence,
    AddDiligence,
    DialogManageStage,
  },
  data() {
    return {
      displayArchive: false,
      displayActive: true,
      suggestionRefresh: true,
      dialogDiligenceData: {
        isShow: false,
        data: {},
        isCreate: true,
      },
      dialogStageData: {
        isShow: false,
      },
      isMinimized: false,
    };
  },
  methods: {
    handleCreateDiligence() {
      if (this.$refs.activeRef && this.$refs.activeRef.diligenceEdit)
        this.$refs.activeRef.diligenceEdit = {};
      this.dialogDiligenceData = {
        isShow: true,
        isCreate: true,
        data: {},
      };
    },
    checkDataStatus() {
      this.$refs.activeRef.checkDataStatus();
    },
    showAddCompany() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item.toLowerCase() == "ADD DILIGENCE COMPANY".toLowerCase()) {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showSuggestions() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item.toLowerCase() == "SHOW SUGGESTIONS".toLowerCase()) {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    handleManageStage() {
      let self = this;
      self.$store
        .dispatch("diligence_stage/apiFetchDiligenceStage")
        .then((data) => {
          self.dialogStageData = {
            isShow: true,
          };
        })
        .catch((err) => {
          console.log("Error", { err });
        });
    },
  },
  watch: {
    portfolioCount: _.debounce(function (data) {
      if (data) {
        this.$store.dispatch("suggestions/getSuggestions");
      }
    }, 0),
  },
  mounted() {
    this.$store.dispatch("diligence/apiFetchDiligence");
    this.$store.dispatch("diligence_stage/apiFetchDiligenceStage");
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | Diligence`;
  },
};
</script>
<style>
.suggestionToggle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  font-size: 10px;
  -webkit-box-shadow: 0px 0px 5px #0000003b;
  box-shadow: 0px 0px 5px #0000003b;
  border: 1px solid #000000;
  position: absolute;
  top: 10px;
  background: #ffffff;
  left: -9px;
  cursor: pointer;
}
.tabulator-edit-select-list {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #00000029;
  border: 1px solid #d8d8d8;
  border-radius: 5px;
}
.tabulator-edit-select-list .tabulator-edit-select-list-item.active {
  background: #fff 0% 0% no-repeat padding-box !important;
  color: #5445f3 !important;
}
.tabulator-edit-select-list .tabulator-edit-select-list-item:hover {
  cursor: pointer !important;
  color: #5445f3 !important;
  background: #e4e3f5 0% 0% no-repeat padding-box !important;
}
.color-picker {
  border: 1px solid rgba(112, 112, 112, 1);
  border-radius: 4px;
  opacity: 1;
  height: 20px;
  width: 20px;
  top: 118px;
  z-index: 2;
  position: absolute;
  right: 60px;
}
.vc-swatches {
  width: 419px;
  height: 240px;
  overflow-y: scroll;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.16);
  margin-top: 66px;
  margin-left: 14px;
}
.tabulator-edit-select-list .tabulator-edit-select-list-item {
  padding: 5px;
  padding-left: 15px;
}

.diligence-table .tabulator-arrow {
  margin-top: 10px !important;
}

.suggestionColCard {
  background-color: rgba(228, 227, 245, 0.12);
  border-left: 1px solid rgba(0, 0, 0, 0.2);
}
</style>
